import MailingElenco from './MailingElenco';
export default MailingElenco;
